import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;
const SESSION_KEY = window.AppConfig.CONST_KEYS;
const ACCOUNTS = 'accounts';

export default class BankService {

    /**
     * This function is delete funding source.
     * @return {Bank}
     */
    static async delete(id) {
        return ApiService.DeleteData(`${API_URLS.FUNDING_SOURCE}/${id}`, ACCOUNTS);
    }

    /**
     * This function is add funding source.
     * @return {Bank}
     */
    static async add(fundingSource) {
        let response = {};
        response = await ApiService.PostData(API_URLS.FUNDING_SOURCE, fundingSource, ACCOUNTS);
        if (response === undefined) {
            return {
                status: false,
                error: SESSION_KEY.SESSION_EXPIRED
            };
        }
        return response;
    }

    /**
     * This function is used to set bank as active.
     * @return {Bank}
     */
    static async setActive(id) {
        const payload = {
            active: true
        };
        return ApiService.PatchData(`${API_URLS.FUNDING_SOURCE}/${id}`, payload, ACCOUNTS);
    }

}
